/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Micro } from '@vds/typography';
import { withCookies } from 'react-cookie';
import { ModalBody } from '@vds/modals';
// import { Tooltip } from '@vds/tooltips';
// import { Notification } from '@vds/notifications';
import AddressLookup from '../address-lookup';
import Button from '../common/Button';
import UnitLookup from '../units-lookup';
import ReCaptcha from '../captcha/recaptcha';
import * as Action from './actions';
import * as checkNotifyAction from '../service-unavailable/actions';
import { updateRecaptchaResponse, updateCurrentView, updateParserAttempt } from '../loop-qual-app/actions';
import SingleColGridLayout from '../common/single-col-grid-layout';
import '../../assets/css/addressLookup.css';
// import Email from '../common/EmailComponent/index.js';
// import Mtn from '../common/Mtn';
import { setModalWindowTitle } from '../common/modal/action';
import Link from '../common/Link';
import Help from './help';
import { dataTrack } from '../../utils/vzdl';
import { AddressQualification as ActionTypes } from '../../constants/actionTypes';
import { logMetrics } from '../../services/logService';
import AddressSuggestion from './addressSuggestion';
import { Pages, LQ_VIEWS, Flowtype } from '../../constants/common';
import { isMYVZWAPP, setToStorage } from '../../utils/lqServiceUtil.js';
import { onHelpClick, onHelpKeyDown } from '../../services/lqService';
import { openViewVzTag, loopQualVzTaglqa, sendDataPassiveLqa, sendDataVzTagMessage, sendDataVzTagLqa, linkVzTag } from '../../utils/unifiedVzTag';
import { emailValidate } from '../common/EmailComponent/action';
import { showLoader, hideLoader } from '../common/loader/actions';
import { setStreetError, setStreetGeoError } from '../address-lookup/actions.js';
import { restoreUnitDefaultsStore, setUnitInputError } from '../units-lookup/actions';
import { getCurrentDocument } from '../../utils/helperUtil.js';

const AddressQualWrapper = styled.div`
  @media (min-width: 768px) {
    min-height: auto;
  }
`;
// const ReskinPaddingForMtnorEmail = styled.div`
//   @media (max-width: 767px) {
//     padding-top: 16px;
//   }
//   @media (min-width: 768px) {
//     padding-top: 16px;
//   }
// `;

const MainSection = styled.div`
  min-width: 500px;
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => (props.justifyContent ? props.justifyContent : 'left')};
  @media (min-width: 275px) and (max-width: 374px) {
    min-width: 250px !important;
  }
  @media (max-width: 767px) {
    min-width: 300px;
    flex-direction: column;
    position: absolute;
    width: 90%;
    button {
      width: 100%;
    }
    @media (max-height: 700px) {
      position: ${(props) => (props.addressSelected ? 'absolute' : 'fixed')};
      bottom: ${(props) => (props.addressSelected ? 'unset' : '16px')};
    }
    @media (min-width: 388px) {
      position: ${(props) => (props.addressSelected ? 'absolute' : 'fixed')};
      bottom: ${(props) => (props.addressSelected ? 'unset' : '16px')};
    }
  }
`;

const LeftSection = styled.div`
  @media (max-width: 767px) {
    width: 100%;
    text-align: center;
    padding-right: 0px;
  }
`;

const StickyCta = styled.div`
  @media (min-width: 768px) {
    background-color: white;
    bottom: 0;
    padding: 24px 0px 0px 0px;
  }
`;

const RightSection = styled.div`
  margin-top: 1rem;
  @media (max-width: 767px) {
    text-align: center;
    display: none;
  }
  @media (min-width: 768px) {
    padding-left: 1rem;
  }
`;
const ReskinNeedHelp = styled.div`
  @media (max-width: 767px) {
    padding-top: 42px;
  }
  @media (min-width: 768px) {
    display: none;
  }
`;
// const WidthofMtnAndEmailReskin = styled.div`
//   width: 100%;
// `;
// const MnHReskinText = styled.div`
//   font-size: 20px;
//   line-height: 20px;
//   font-weight: 400;
//   font-family: Verizon-NHG-eDS;
//   padding: 0px 0px 24px 0px;
//   color: #6f7171;
// `;

const PrivacyPolicy = styled.div`
  @media (min-width: 768px) {
    display: none;
  }
`;
const PrivacyPolicyMobile = styled.div`
  @media (max-width: 767px) {
    display: none;
  }
`;

const VfSubModal = styled.div`
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  font-family: Verizon-NHG-eDS;
  @media (max-width: 767px) {
    font-size: 20px;
  }
`;

class AddressQualification extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      validEmail: true,
      validMtn: true,
      // notificationButtonData: [],
      // helperText: '',
      isMovers:
        (this.props.loopQualApp.flowType && this.props.loopQualApp.flowType === Flowtype.MOVERS) ||
        (window.location.search && window.location.search.toLowerCase().indexOf('move=y') > -1),
      isVfEmailNC: this.props.loopQualApp.isVfEc && window.sessionStorage.getItem('isVfEmailNC') === 'true',
    };
    this.retailQrCode = this.props.loopQualApp.flowType === Flowtype.retail;
    this.storeLocater = this.props.loopQualApp.flowType === Flowtype.storeLocater;
    this.getDocument = getCurrentDocument();
  }

  componentDidMount() {
    let pathName = window.location.pathname && window.location.pathname.toLowerCase();
    if (pathName === '/home/' || pathName === '/home') {
      pathName = pathName.replace('/home', '/hub-home');
    }
    const bodyClass = document.querySelector('body').className;
    if (this.streetAddressSelected()) {
      if (bodyClass.indexOf('hide-focus-outline') === -1) {
        const unitInput = this.getDocument.querySelector('#apartmentNumber');
        const mobileDivWrapper = this.getDocument.querySelector('#Mobile-phone-number');
        const mobileInput = mobileDivWrapper && mobileDivWrapper.querySelector('input') ? mobileDivWrapper.querySelector('input') : mobileDivWrapper;
        if (unitInput) {
          unitInput.focus();
          if (this.props.loopQualApp?.homeLQ) {
            linkVzTag('lq sticky bar apt - clicked', 'lq banner');
          } else if (this.props.loopQualApp?.lq4) {
            linkVzTag('lq sticky bar apt - clicked', 'lq sticky bar');
          } else {
            linkVzTag('lq check avail apt - clicked', 'lq check avail');
          }
        } else if (mobileInput) {
          mobileInput.focus();
        }
      }
    }
    let modalTitle = '';
    modalTitle = this.props.addressQualification.helpView
      ? 'Need help'
      : this.state.isMovers
      ? this.props.loopQualApp.isMvph2
        ? "Let's get moving."
        : "What's your new address?"
      : this.state.isVfEmailNC
      ? 'Great, you qualify for the Verizon Forward discount.'
      : "Let's see what's available.";
    if (this.props.modalOverlay && this.props.modalOverlay.modalTitle !== modalTitle) {
      setModalWindowTitle(modalTitle, this.props.dispatch);
    }
    if (this.state.isMovers && (this.props.loopQualApp.isLoggedIn || this.props.loopQualApp.isLoggedInUserInfo)) {
      if (this.props.loopQualApp.isLoggedIn) {
        if (this.props.moveDetails.preferredMVService.lineLevelInfo) {
          openViewVzTag('lq check avail');
        } else if (this.state.isVfEmailNC) {
          openViewVzTag('lq check avail |vfemail');
        } else {
          openViewVzTag('mobility|aal|move');
        }
      } else if (this.props.loopQualApp.isLoggedInUserInfo) {
        openViewVzTag('lq check avail |wireline');
      }
    } else if (this.props.loopQualApp.isComboMFJT) {
      openViewVzTag('lq check avail');
    }
  }

  componentDidUpdate(prevProps) {
    let modalTitle = '';
    modalTitle = this.props.addressQualification.helpView
      ? 'Need help'
      : this.state.isMovers
      ? this.props.loopQualApp.isMvph2
        ? "Let's get moving."
        : "What's your new address?"
      : this.state.isVfEmailNC
      ? 'Great, you qualify for the Verizon Forward discount.'
      : "Let's see what's available.";
    if (this.props.modalOverlay && this.props.modalOverlay.modalTitle !== modalTitle) {
      setModalWindowTitle(modalTitle, this.props.dispatch);
    }
    if (this.props.customerStreetDetails === null && prevProps.customerStreetDetails !== null) {
      restoreUnitDefaultsStore(this.props.dispatch);
    }
    if (!prevProps.addressQualification.manualValidationClick && this.props.addressQualification.manualValidationClick) {
      setTimeout(() => {
        const button = this.getDocument.querySelector('#notification-button');
        if (button) {
          button.focus();
        }
      }, 100);
    }
  }

  streetAddressSelected = () => {
    const { customerStreetDetails } = this.props;
    return customerStreetDetails !== null;
  };

  // onClick = () => {
  //   try {
  //     const emailAddress = this.props.addressQualification.scEmail ? this.props.addressQualification.scEmail : '';
  //     emailVerify(emailAddress, this.props.loopQualApp.isLoggedIn, this.props.dispatch)
  //       .then((response) => {
  //         if (response && response.data && response.data.error && response.data.error === 'Error in validating the email') {
  //           this.onEmailValidation(true, false, 'Please enter a valid email address.');
  //           this.onEmailChange(emailAddress, false);
  //           this.props.dispatch({ type: ActionTypes.MANUAL_VALIDATION_CLICK, value: false });
  //         }
  //         this.props.dispatch({ type: ActionTypes.MANUAL_VALIDATION_CLICK, value: true });
  //         sendDataVzTagMessage('Please check your email. After validating your email address, click on confirm below');
  //       })
  //       .catch((error) => {
  //         console.log('email-verify-error:\t', error);
  //         this.props.dispatch({ type: ActionTypes.MANUAL_VALIDATION_CLICK, value: false });
  //       });
  //   } catch (error) {
  //     console.log('emailVerify:\t', error);
  //   }
  // };

  emailValidation = (emailAddress) => {
    try {
      if (
        this.props.loopQualApp.isLoggedIn &&
        this.props.loopQualApp.roleType &&
        (this.props.loopQualApp.roleType === 'prepay' || this.props.loopQualApp.roleType === 'guest')
      ) {
        this.props.dispatch(updateCurrentView(LQ_VIEWS.LBO_VIEW));
        return true;
      }
      const maxAttemptReached = window.sessionStorage.getItem('maxAttemptReached');
      if (emailAddress && !maxAttemptReached) {
        logMetrics('emailValidation', 'email validation from address qualification', 'Info');
        this.props.dispatch(showLoader());
        emailValidate(emailAddress, this.props.loopQualApp, this.props.dispatch)
          .then((response) => {
            console.log(`validateResponse - response.data.valid${response.data.valid}`);
            this.props.dispatch({
              type: ActionTypes.VALIDATE_EMAIL_ADDRESS,
              value: response && response.data && response.data.valid ? response.data.valid : '',
            });
            this.props.dispatch(hideLoader());
            if (response && (response.data.valid === 'Valid' || response.data.valid === 'White_listed')) {
              this.onEmailValidation(false, true, '');
              this.onEmailChange(emailAddress, true);
              sendDataVzTagMessage(response.data.valid === 'White_listed' ? 'whitelisted-email' : 'valid-email');
              this.checkAvailability();
            } else if (
              (response && response.data.valid === 'true' && response.data.serviceAvailable === 'false') ||
              response.data.valid === 'Fake' ||
              response.data.valid === 'Invalid'
            ) {
              this.onEmailValidation(true, false, 'Please enter a valid email address.');
              this.onEmailChange(emailAddress, false);
              sendDataVzTagMessage(
                response.data.valid === 'Invalid'
                  ? 'please enter a valid email address|invalid'
                  : response.data.valid === 'Fake'
                  ? 'please enter a valid email address|fake'
                  : 'please enter a valid email address|serviceUnavailable',
              );
            } else if (response && response.data && response.data.valid === 'Manual_validation') {
              const manualText = 'Please click here to validate your email address or enter a different one';
              sendDataVzTagMessage(manualText);
              console.log(`manualText${manualText}`);
              this.onEmailValidation(true, false, '');
              this.onEmailChange(emailAddress, false);
              const emailLink = this.getDocument.querySelectorAll('.emailLink');
              emailLink?.focus();
            } else if (response && response.data.valid === 'false') {
              this.onEmailValidation(true, false, "You've changed your email address too many times. Please try again later.");
              this.onEmailChange(emailAddress, false);
              setToStorage('maxAttemptReached', true);
              sendDataVzTagMessage('max-email-attempts');
              logMetrics('emailValidation', 'maximum attempt has reached for email validation', 'Info');
            } else if (response && response.data && response.data.errors && response.data.errors[0] && response.data.errors[0].name) {
              this.onEmailValidation(true, false, 'Please enter a valid email address.');
              this.onEmailChange(emailAddress, false);
            } else {
              this.onEmailValidation(true, false, 'Please enter a valid email address.');
              this.onEmailChange(emailAddress, false);
            }
            this.props.dispatch({ type: ActionTypes.VALIDATE_EMAIL_REGEX, value: false });
            this.props.dispatch({ type: ActionTypes.MANUAL_VALIDATION_CLICK, value: false });
          })
          .catch((error) => {
            this.props.dispatch(hideLoader());
            console.log('emailValidation:\t', error);
          });
      } else if (emailAddress && maxAttemptReached) {
        this.onEmailValidation(true, false, "You've changed your email address too many times. Please try again later.");
        this.onEmailChange(emailAddress, false);
      }
    } catch (error) {
      this.props.dispatch(hideLoader());
      console.log('emailValidation:\t', error);
    }
  };

  onKeyDown = (e) => {
    const email = this.getDocument.querySelector('#Email-address-field');
    const keyCode = e.which ? e.which : e.keyCode;
    if (keyCode && keyCode === 38) {
      email.focus();
    }
  };

  emailcheck = () => {
    try {
      let emailAddress = '';
      const wirelineSkipForLowerEnv =
        window.location.host.includes('awssit.ebiz.verizon.com') ||
        window.location.host.includes('nte1aws.ebiz.verizon.com') ||
        window.location.host.includes('98.verizon.com') ||
        window.location.host.includes('preprod-east-gz.vpc.verizon.com');
      if (this.props.loopQualApp && this.props.loopQualApp.isLoggedIn) {
        emailAddress = this.props.addressQualification.lqResult.emailAddress
          ? this.props.addressQualification.lqResult.emailAddress
          : this.props.addressQualification.scEmail
          ? this.props.addressQualification.scEmail
          : '';
      } else {
        emailAddress = this.props.addressQualification.scEmail ? this.props.addressQualification.scEmail : '';
      }
      if (emailAddress && !wirelineSkipForLowerEnv) {
        this.emailValidation(emailAddress);
      } else if (this.props.customerStreetDetails) {
        this.checkAvailability();
      } else if (this.props.loopQualApp.isMvph2) {
        if (this.props.streetInput.length === 0) {
          // this.props.dispatch(streetEmptyError(true));
          this.props.dispatch(setStreetError(true));
          this.props.dispatch(setStreetGeoError(false));
          return true;
        }
        if (this.props.streetInput.length < 10 || !this.props.customerStreetDetails) {
          this.props.dispatch(setStreetError(true));
          this.props.dispatch(setStreetGeoError(false));
          return true;
        }
      } else {
        this.props.dispatch(setStreetError(true));
        this.props.dispatch(setStreetGeoError(false));
      }
    } catch (error) {
      console.log('emailcheck:\t', error);
      logMetrics('emailValidation', 'email validation from addressqual failed', 'Info');
      this.checkAvailability();
    }
  };

  checkAvailability = () => {
    if (
      this.props.loopQualApp.isLoggedIn &&
      this.props.loopQualApp.roleType &&
      (this.props.loopQualApp.roleType === 'prepay' || this.props.loopQualApp.roleType === 'guest')
    ) {
      this.props.dispatch(updateCurrentView(LQ_VIEWS.LBO_VIEW));
      return true;
    }
    if (this.state.isMovers) {
      if (window.sessionStorage.getItem('isMovers')) {
        window.sessionStorage.removeItem('isMovers');
      }
      document.cookie = 'isMovers=false;path=/';

      if (this.props.loopQualApp.isMvph2) {
        if (this.props.streetInput.length === 0) {
          this.props.dispatch(setStreetError(true));
          // this.props.dispatch(streetEmptyError(true));
          this.props.dispatch(setStreetGeoError(false));
          return true;
        }
        if (this.props.streetInput.length < 10 || !this.props.customerStreetDetails) {
          this.props.dispatch(setStreetError(true));
          this.props.dispatch(setStreetGeoError(false));
          return true;
        }
      }
    }
    let bussinessView = false;
    if (this.props.unitLookupDetails.customerUnitDetails && this.props.unitLookupDetails.customerUnitDetails.propertyType === 'B') {
      bussinessView = true;
    } else if (this.props.customerStreetDetails && this.props.customerStreetDetails.propertyType === 'B') {
      bussinessView = !this.props.unitLookupDetails.customerUnitDetails;
    }
    logMetrics('checkAvailability', 'checkAvailability_continueClick', 'Info');
    if (this.props.loopQualApp?.isACPFlow) {
      if (window.sessionStorage.getItem('isVfExist') === 'true') {
        this.props.dispatch({ type: ActionTypes.SC_VFP, value: true });
      } else if (window.sessionStorage.getItem('isAcpExist') === 'true') {
        this.props.dispatch({ type: ActionTypes.SC_ACP, value: true });
      }
    }

    if (this.props.customerStreetDetails) {
      if (this.props.addressQualification.lqResult.suggestedAddress && this.props.customerStreetDetails.multipleAddress === 'Y') {
        if (this.storeLocater) {
          sendDataPassiveLqa('lq-multiple-address', 'sl');
        } else {
          loopQualVzTaglqa('lq multiple address verification');
        }
      } else if (this.storeLocater) {
        sendDataPassiveLqa('lq-address', 'sl');
      } else if (this.props.loopQualApp && this.props.loopQualApp.sourceInfo && this.props.loopQualApp.sourceInfo === 'digitalCombo') {
        sendDataVzTagLqa('single');
      } else if (this.props.loopQualApp && this.props.loopQualApp.isFccFlow) {
        sendDataPassiveLqa('lq-address', 'fcc');
      } else {
        loopQualVzTaglqa(this.props.loopQualApp.lq4 ? 'lq address verification |lqa sticky bar' : 'lq address verification');
      }
    } else {
      this.props.dispatch(updateParserAttempt(this.props.parserAttempt + 1));
    }
    if (bussinessView) {
      this.props.dispatch(updateCurrentView(LQ_VIEWS.BUSINESSADDRESS_VIEW));
    } else if (
      this.props.unitLookupDetails?.isUnitRequired &&
      (this.props.unitLookupDetails?.unitInputError || !this.props.unitLookupDetails?.unitSelected)
    ) {
      this.props.dispatch(setUnitInputError(true));
    } else {
      Action.checkNetworkAvailability(
        this.props.customerStreetDetails,
        this.props.unitLookupDetails,
        this.props.addressQualification,
        this.props.loopQualApp,
        this.props.dispatch,
        this.props.cookies,
        this.props.streetInput,
        this.props.fiosDetails,
        this.props.moveDetails,
        this.props.bulkQualDetails,
        false,
        true,
      );
    }
  };

  onCaptcheComplete = (value) => {
    this.props.dispatch(updateRecaptchaResponse(value));
    logMetrics('captcha', 'onCaptcheComplete', 'Info');
  };

  onEmailChange = (event, status) => {
    if (event && event.target) {
      this.props.dispatch(Action.updateEmailInput(event.target.value));
      this.props.dispatch(checkNotifyAction.updateEmailInput(event.target.value));
    } else {
      this.props.dispatch(Action.updateEmailInput(event));
      this.props.dispatch(checkNotifyAction.updateEmailInput(event));
    }
    this.props.dispatch(checkNotifyAction.emailValidFlag(status));
    this.setState({ validEmail: status });
  };

  // onPhoneChange = (value, status) => {
  //   const mtn = value;
  //   const formattedmtn = value.replace(/\./g, '');
  //   this.props.dispatch(Action.updatePhoneInput(mtn));
  //   this.props.dispatch(Action.updateFormattedPhoneInput(formattedmtn));
  //   this.props.dispatch(checkNotifyAction.updatePhoneInput(mtn));
  //   this.props.dispatch(checkNotifyAction.updateFormattedPhoneInput(formattedmtn));
  //   this.props.dispatch(checkNotifyAction.phoneValidFlag(status));
  //   this.setState({ validMtn: status });
  // };

  onEmailValidation = (errorValue, successValue, errorTextValue) => {
    this.props.dispatch({ type: ActionTypes.ERROR, value: errorValue });
    this.props.dispatch({ type: ActionTypes.SUCCESS, value: successValue });
    this.props.dispatch({ type: ActionTypes.ERROR_TEXT_FOR_EMAIL, value: errorTextValue });
  };

  onPrivacyKeyDown = (e) => {
    if (e.charCode === 13) {
      this.onPrivacyClick(e);
    }
  };

  onPrivacyClick = (e) => {
    e.preventDefault();
    if (isMYVZWAPP()) {
      window.location.replace(Pages.privacyLink);
    } else {
      window.open(Pages.privacyLink, '_blank');
    }
  };

  // renderMtnRender(addressSelected) {
  //   let emailAddress = '';
  //   if (this.props.loopQualApp && this.props.loopQualApp.isLoggedIn) {
  //     emailAddress = this.props.addressQualification.lqResult.emailAddress
  //       ? this.props.addressQualification.lqResult.emailAddress
  //       : this.props.addressQualification.scEmail
  //       ? this.props.addressQualification.scEmail
  //       : '';
  //   } else {
  //     emailAddress = this.props.addressQualification.scEmail ? this.props.addressQualification.scEmail : '';
  //   }
  //   const toolTipText = 'For security,we need to confirm this email address is valid.';
  //   const NotificationSubTitle = `We've sent an email to ${emailAddress}. After validating your email address, click Confirm below.`;
  //   return (
  //     <>
  //       <div className="loop-qualification" style={{ visibility: addressSelected ? 'visible' : 'hidden' }}>
  //         {!this.state.isVfEmailNC && (
  //           <>
  //             <WidthofMtnAndEmailReskin>
  //               <ReskinPaddingForMtnorEmail>
  //                 <Mtn
  //                   data-testid="mobile-phone-number-id"
  //                   onChange={this.onPhoneChange}
  //                   width={this.state.width}
  //                   {...this.props}
  //                   required
  //                   value={this.props.addressQualification.scMtn}
  //                   isValid={this.state.validMtn}
  //                   notify={this.props.notify}
  //                   helperText="Enter your Verizon Wireless phone number to see if you qualify for an exclusive discount. Message and data rates may apply."
  //                 />
  //               </ReskinPaddingForMtnorEmail>
  //               <br />
  //               <ReskinPaddingForMtnorEmail>
  //                 <Email
  //                   data-testid="email-test-id"
  //                   onChange={this.onEmailChange}
  //                   onEmailValidation={this.onEmailValidation}
  //                   {...this.props}
  //                   errorState={this.errorState}
  //                   required
  //                   value={this.props.addressQualification.scEmail}
  //                   isValid={this.state.validEmail}
  //                   helperText="Keep me posted on products and services available to me."
  //                 />
  //               </ReskinPaddingForMtnorEmail>
  //               <br />
  //             </WidthofMtnAndEmailReskin>
  //           </>
  //         )}
  //         {!this.props.addressQualification.manualValidationClick && this.props.validateEmailAddress === 'Manual_validation' && (
  //           <div>
  //             <div className="emailLink" tabIndex="0" aria-live="polite">
  //               Please{' '}
  //               <a
  //                 onClick={this.onClick}
  //                 onKeyUp={this.onClick}
  //                 aria-label="Please Click here to validate your email address or enter a different one."
  //                 data-track={dataTrack('link', 'email-validation-click-here')}
  //                 tabIndex="0"
  //               >
  //                 click here
  //               </a>{' '}
  //               to validate your email address or enter a different one.
  //               <Tooltip title="" size="small" inverted={false}>
  //                 {toolTipText}
  //               </Tooltip>
  //             </div>
  //             <span style={{ color: '#6f7171' }}>{(this.state.helperText = 'Keep me posted on products and services available to me.')}</span>
  //           </div>
  //         )}
  //         {this.props.addressQualification.manualValidationClick && (
  //           <Notification
  //             type="info"
  //             title="Please check your email."
  //             subtitle={NotificationSubTitle}
  //             fullBleed
  //             inlineTreatment
  //             hideCloseButton
  //             layout={this.state.notificationButtonData && this.state.notificationButtonData.length ? 'horizontal' : 'vertical'}
  //             buttonData={[
  //               {
  //                 children: 'Confirm',
  //                 onClick: () => this.emailValidation(emailAddress),
  //                 'data-track': '{"type":"link", "name":"email-validation-confirm"}',
  //                 tabIndex: '0',
  //                 ariaLabel: 'Please check your email.',
  //                 id: 'notification-button',
  //               },
  //             ]}
  //           />
  //         )}
  //       </div>
  //     </>
  //   );
  // }

  renderShowLqContinue(addressSelected, enableAvailabilityCheck, checkAvailBtnTrack) {
    return (
      <>
        <MainSection id="main-section" addressSelected={addressSelected} customerStreetDetails={this.props.customerStreetDetails}>
          <LeftSection>
            <Button
              data-testid="continue-cta"
              id="continue-cta"
              onClick={this.emailcheck}
              onKeyDown={this.onKeyDown}
              disabled={this.props.loopQualApp.isMvph2 ? false : !enableAvailabilityCheck}
              data-track={dataTrack('link', checkAvailBtnTrack)}
            >
              {this.props.loopQualApp.staticContent?.ADDRESS_QUALIFICATION?.QUALIFICATION_CTA_LABEL}
            </Button>
          </LeftSection>
          <RightSection>
            <Link
              onClick={(e) => onHelpClick(e, this.props.dispatch)}
              onKeyPress={(e) => onHelpKeyDown(e, this.props.dispatch)}
              linkText={this.props.loopQualApp.staticContent?.ADDRESS_QUALIFICATION?.NEED_HELP_TEXT_LINK}
              style={{ marginBottom: '6px' }}
              data-track={dataTrack('link', 'help')}
              role="button"
            />
          </RightSection>
          {addressSelected && (
            <>
              <br />
              <PrivacyPolicy>
                <Micro>
                  <span style={{ display: 'flex' }}>
                    By continuing, you agree to the
                    <Link
                      data-testid="privacy-policy-id"
                      style={{ fontSize: '0.6875rem', paddingLeft: '3px' }}
                      ariaLabel="privacy policy opens in a new tab"
                      className="link"
                      onClick={(e) => this.onPrivacyClick(e)}
                      onKeyPress={(e) => this.onPrivacyKeyDown(e)}
                      linkText="privacy policy"
                      data-track={dataTrack('link', 'privacy policy')}
                    />
                    .
                  </span>
                </Micro>
              </PrivacyPolicy>
            </>
          )}
        </MainSection>
        {addressSelected && (
          <>
            <br />
            <PrivacyPolicyMobile>
              <Micro>
                <span style={{ display: 'flex' }}>
                  By continuing, you agree to the
                  <Link
                    style={{ fontSize: '0.6875rem', paddingLeft: '3px' }}
                    ariaLabel="privacy policy opens in a new tab"
                    className="link"
                    onClick={(e) => this.onPrivacyClick(e)}
                    onKeyPress={(e) => this.onPrivacyKeyDown(e)}
                    linkText="privacy policy"
                    data-track={dataTrack('link', 'privacy policy')}
                  />
                  .
                </span>
              </Micro>
            </PrivacyPolicyMobile>
          </>
        )}
      </>
    );
  }

  render() {
    const { customerStreetDetails, isUnitRequired, unitLookupDetails, showLqCta, loopQualApp, parserAttempt } = this.props;
    const { reCaptchaSiteKey, gCaptchaResponse } = loopQualApp.captchaDetails;
    let reCaptchaEnabled = loopQualApp.captchaDetails.reCaptchaEnabled === 'Y';
    const enableParser = !!(this.props.parserAttempt < 7 && this.props.loopQualApp.flowType !== Flowtype.MOVERS);
    const validEmail = this.props.addressQualification.validateEmailAddress === '' ? this.state.validEmail : this.props.notify?.onEmailValid;
    let enableAvailabilityCheck =
      (customerStreetDetails != null || (enableParser && customerStreetDetails === null && showLqCta)) &&
      (isUnitRequired ? unitLookupDetails && unitLookupDetails.customerUnitDetails != null : true) &&
      (reCaptchaEnabled ? gCaptchaResponse && gCaptchaResponse.length : true) &&
      this.state.validEmail &&
      this.state.validMtn;
    const addressSelected = customerStreetDetails != null;
    if (loopQualApp.runTimeKey && loopQualApp.runTimeKey.EnableCaptcha && loopQualApp.runTimeKey.EnableCaptcha === 'N') {
      enableAvailabilityCheck =
        (customerStreetDetails != null || (enableParser && customerStreetDetails === null && showLqCta)) &&
        (isUnitRequired ? unitLookupDetails && unitLookupDetails.customerUnitDetails != null : true) &&
        validEmail &&
        this.state.validMtn;
      reCaptchaEnabled = false;
    }
    if (
      this.props.loopQualApp.flowType === Flowtype.MOVERS &&
      this.props.addressQualification.lqResult &&
      this.props.addressQualification.lqResult.mvInvAdr
    ) {
      enableAvailabilityCheck = false;
    }
    const checkAvailBtnTrack =
      this.props.addressQualification.scEmail !== '' && this.props.addressQualification.scMtn !== ''
        ? 'check avail - mtn and email'
        : this.props.addressQualification.scEmail !== ''
        ? 'check avail - email'
        : this.props.addressQualification.scMtn !== ''
        ? 'check avail - mtn'
        : 'check avail';
    // const mtnEmailRender =
    //   false &&
    //   !this.storeLocater &&
    //   !this.retailQrCode &&
    //   (addressSelected || this.props.addressQualification.lqResult.suggestedAddress) &&
    //   !this.state.isMovers &&
    //   !this.props.loopQualApp.isACPFlow &&
    //   !this.props.loopQualApp.TWS &&
    //   !this.props.loopQualApp.newConnection &&
    //   !this.props.loopQualApp.isComboMFJT &&
    //   !this.props.loopQualApp.isECComboMFJT &&
    //   this.renderMtnRender(addressSelected);
    const reCaptchaRender = reCaptchaEnabled && addressSelected && (
      <ReCaptcha
        onChange={this.onCaptcheComplete}
        siteKey={window.location.hostname === 'localhost' ? '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' : reCaptchaSiteKey}
      />
    );
    const showLqCtaRender = this.renderShowLqContinue(addressSelected, enableAvailabilityCheck, checkAvailBtnTrack);
    return (
      <AddressQualWrapper>
        {this.props.addressQualification.helpView && (
          <Help loopQualApp={this.props.loopQualApp} addressQualification={this.props.addressQualification} dispatch={this.props.dispatch} />
        )}
        {!this.props.loopQualApp.homeLQ &&
          !this.props.addressQualification.helpView &&
          this.props.addressQualification.lqResult?.suggestedAddress && (
            <>
              <AddressSuggestion
                fiosDetails={this.props.fiosDetails}
                loopQualApp={loopQualApp}
                addressQualification={this.props.addressQualification}
                lqResult={this.props.addressQualification.lqResult}
                customerStreetDetails={customerStreetDetails}
                parserAttempt={parserAttempt}
                dispatch={this.props.dispatch}
                parserAddressID={this.props.parserAddressID}
                parserShowAll={this.props.parserShowAll}
              />
              {/* {mtnEmailRender} */}
              {reCaptchaRender}
              {addressSelected && showLqCtaRender}{' '}
            </>
          )}
        {!this.props.loopQualApp.homeLQ &&
          !this.props.addressQualification.helpView &&
          !this.props.addressQualification.lqResult?.suggestedAddress && (
            <SingleColGridLayout
              rowGutter="15px"
              colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}
              renderPredicate={{ 1: isUnitRequired, 2: this.props.streetInput !== '', 3: reCaptchaEnabled }}
            >
              <>
                <ModalBody>
                  {/* {addressSelected && !this.state.isMovers && !this.state.isVfEmailNC && (
                  <MnHReskinText>{loopQualApp.staticContent.ADDRESS_QUALIFICATION.MHREWARDS_TEXT_RESKIN_WILLOW}</MnHReskinText>
                )} */}
                  {this.state.isVfEmailNC && (
                    <VfSubModal>Let’s confirm your address before you continue to purchase services with the discount.</VfSubModal>
                  )}
                  <AddressLookup
                    loopQualApp={this.props.loopQualApp}
                    staticContent={loopQualApp.staticContent?.ADDRESS_LOOKUP}
                    noSuggestedAddress={this.props.addressQualification.lqResult?.noSuggestedAddress}
                  />
                  {addressSelected && <UnitLookup mvInvAdr={this.props.addressQualification.lqResult?.mvInvAdr} />}
                  {/* {mtnEmailRender} */}
                  <ReskinNeedHelp>
                    <Link
                      data-testid="need-help"
                      onClick={(e) => onHelpClick(e, this.props.dispatch)}
                      onKeyPress={(e) => onHelpKeyDown(e, this.props.dispatch)}
                      linkText={loopQualApp.staticContent?.ADDRESS_QUALIFICATION?.NEED_HELP_TEXT_LINK}
                      style={{ marginBottom: '32px' }}
                      data-track={dataTrack('link', 'help')}
                      role="button"
                    />
                  </ReskinNeedHelp>
                  {reCaptchaRender}
                </ModalBody>
                <StickyCta>
                  {/* <footer>{showLqCtaRender}</footer> */}
                  {showLqCtaRender}
                </StickyCta>
              </>
            </SingleColGridLayout>
          )}
      </AddressQualWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  addressQualification: state.addressQualification,
  customerStreetDetails: state.addressLookup.customerStreetDetails,
  streetInput: state.addressLookup.streetInput,
  units: state.unitLookup.units,
  isUnitRequired: state.unitLookup.isUnitRequired,
  unitLookupDetails: state.unitLookup,
  isReCaptcheValidated: state.addressLookup.isReCaptcheValidated,
  modalOverlay: state.modalOverlay,
  loopQualApp: state.loopQualApp,
  showLqCta: state.addressLookup.showLqCta,
  parserAttempt: state.addressLookup.parserAttempt,
  parserAddressID: state.addressLookup.parserAddressID,
  parserShowAll: state.addressLookup.parserShowAll,
  fiosDetails: state.fiosDetails,
  moveDetails: state.moveDetails,
  validateEmailAddress: state.addressQualification.validateEmailAddress,
  notify: state.notify,
  bulkQualDetails: state.bulkQualDetails,
});
export default withCookies(connect(mapStateToProps)(AddressQualification));

AddressQualification.propTypes = {
  modalOverlay: PropTypes.string,
  addressQualification: PropTypes.string,
  dispatch: PropTypes.string,
  customerStreetDetails: PropTypes.string,
  unitLookupDetails: PropTypes.string,
  cookies: PropTypes.string,
  units: PropTypes.string,
  streetInput: PropTypes.string,
  isUnitRequired: PropTypes.string,
  showLqCta: PropTypes.string,
  parserAttempt: PropTypes.number,
  loopQualApp: PropTypes.string,
  notify: PropTypes.string,
  fiosDetails: PropTypes.object,
  parserAddressID: PropTypes.string,
  parserShowAll: PropTypes.bool,
  validateEmailAddress: PropTypes.string,
  moveDetails: PropTypes.object,
  bulkQualDetails: PropTypes.any,
};
